/*=========================================================================================
  File Name: module-auth-getters.js
  Description: Auth Module Getters
  ----------------------------------------------------------------------------------------
  Project: MISA MTAX WebApp
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/

export default {
	getUser: function(state) {
		return state.user;
	},
	getMessage: function(state) {
		return state.message;
	},
	userInfo: function(state) {
		return state.userInfo;
	},
	getEmailActive: function(state) {
		return state.EmailActive;
	},
	getPhoneActive: function(state) {
		return state.PhoneActive;
	},
	getIsLaterState: function(state) {
		return state.isLater;
	},
	timeOut: function(state) {
		return state.timeOut;
	},
	misaAccessToken: function(state) {
		return state.misaAccessToken;
	},
	misaRefreshToken: function(state) {
		return state.misaRefreshToken;
	},
	isShowWarningLisence: function(state) {
		return state.isShowWarningLisence;
	},
	isRequiredLicense: function(state) {
		return state.isRequiredLicense;
	},
	getAmisAuthData: function(state) {
		return state.amisAuthData;
	}
};
